export type Universe = 'hogwarts-legacy' | 'space-marine' | 'medieval' | 'fantastic';
export type ThemeColor = 'purple' | 'blue' | 'green' | 'amber' | 'rose' | 'teal' | 'orange' | 'red' | 'indigo' | 'emerald';

export const themeColors: Record<ThemeColor, { 
  bg: string;
  text: string;
  accent: string;
  from: string;
  to: string;
}> = {
  purple: {
    bg: 'bg-gradient-to-br from-purple-500 to-indigo-500',
    text: 'text-purple-900',
    accent: 'bg-purple-50',
    from: 'from-purple-500',
    to: 'to-indigo-500'
  },
  blue: {
    bg: 'bg-gradient-to-br from-blue-500 to-sky-500',
    text: 'text-blue-900',
    accent: 'bg-blue-50',
    from: 'from-blue-500',
    to: 'to-sky-500'
  },
  green: {
    bg: 'bg-gradient-to-br from-emerald-500 to-green-500',
    text: 'text-emerald-900',
    accent: 'bg-emerald-50',
    from: 'from-emerald-500',
    to: 'to-green-500'
  },
  amber: {
    bg: 'bg-gradient-to-br from-amber-500 to-orange-500',
    text: 'text-amber-900',
    accent: 'bg-amber-50',
    from: 'from-amber-500',
    to: 'to-orange-500'
  },
  rose: {
    bg: 'bg-gradient-to-br from-rose-500 to-pink-500',
    text: 'text-rose-900',
    accent: 'bg-rose-50',
    from: 'from-rose-500',
    to: 'to-pink-500'
  },
  teal: {
    bg: 'bg-gradient-to-br from-teal-500 to-cyan-500',
    text: 'text-teal-900',
    accent: 'bg-teal-50',
    from: 'from-teal-500',
    to: 'to-cyan-500'
  },
  orange: {
    bg: 'bg-gradient-to-br from-orange-500 to-red-500',
    text: 'text-orange-900',
    accent: 'bg-orange-50',
    from: 'from-orange-500',
    to: 'to-red-500'
  },
  red: {
    bg: 'bg-gradient-to-br from-red-500 to-rose-500',
    text: 'text-red-900',
    accent: 'bg-red-50',
    from: 'from-red-500',
    to: 'to-rose-500'
  },
  indigo: {
    bg: 'bg-gradient-to-br from-indigo-500 to-violet-500',
    text: 'text-indigo-900',
    accent: 'bg-indigo-50',
    from: 'from-indigo-500',
    to: 'to-violet-500'
  },
  emerald: {
    bg: 'bg-gradient-to-br from-emerald-500 to-teal-500',
    text: 'text-emerald-900',
    accent: 'bg-emerald-50',
    from: 'from-emerald-500',
    to: 'to-teal-500'
  }
};

export const universeLabels: Record<Universe, string> = {
  'hogwarts-legacy': 'Hogwarts Legacy',
  'space-marine': 'Space Marine',
  'medieval': 'Médiéval',
  'fantastic': 'Fantastique'
};

export const universeCharacteristics: Record<Universe, string[]> = {
  'hogwarts-legacy': [
    'Maison',
    'Baguette',
    'Patronus',
    'Matières préférées',
    'Familier'
  ],
  'space-marine': [
    'Chapitre',
    'Rang',
    'Spécialisation',
    'Équipement',
    'Campagnes'
  ],
  'medieval': [
    'Titre',
    'Fief',
    'Armes',
    'Blason',
    'Alliances'
  ],
  'fantastic': [
    'Race',
    'Classe',
    'Alignement',
    'Compétences',
    'Équipement'
  ]
};

export const seasonalThemes = {
  halloween: {
    colors: {
      primary: '#ff6b00',
      secondary: '#8b00ff',
      accent: '#000000',
      background: 'bg-gradient-to-br from-orange-500 to-purple-900'
    },
    icons: {
      profile: '🎃',
      background: '👻'
    },
    startDate: '10-01',
    endDate: '11-01'
  },
  christmas: {
    colors: {
      primary: '#ff0000',
      secondary: '#00ff00',
      accent: '#ffffff',
      background: 'bg-gradient-to-br from-red-600 to-green-700'
    },
    icons: {
      profile: '🎅',
      background: '🎄'
    },
    startDate: '12-01',
    endDate: '12-31'
  },
  summer: {
    colors: {
      primary: '#ff9900',
      secondary: '#00ccff',
      accent: '#ffff00',
      background: 'bg-gradient-to-br from-yellow-400 to-blue-500'
    },
    icons: {
      profile: '🌞',
      background: '🏖️'
    },
    startDate: '06-21',
    endDate: '09-21'
  },
  winter: {
    colors: {
      primary: '#00ffff',
      secondary: '#ffffff',
      accent: '#0000ff',
      background: 'bg-gradient-to-br from-blue-300 to-indigo-600'
    },
    icons: {
      profile: '⛄',
      background: '❄️'
    },
    startDate: '12-21',
    endDate: '03-20'
  }
};